module.exports = __webpack_public_path__ + "media/img/pages/companies/helvetia-dd3aff4f3d70474d2b2707d3bab79d56.jpg";